import { createGlobalStyle } from 'styled-components';
import { ThemeProviderColors, ThemeProps } from '../interfaces';

export const VacationStyles = createGlobalStyle`
   [id*='vacationType-list'] {
    background: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.popupInputMainBackground};
    color: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.textMainColor};

    &:hover {
        background: ${(props: ThemeProps<ThemeProviderColors>) =>
          props.theme.popupVacationHoverBackground};
        color: ${(props: ThemeProps<ThemeProviderColors>) =>
          props.theme.textMainColor};  
    }    
  };

  [class*='ms-Callout'][class*='ms-Dropdown-callout'][class*='callout-'],
  [class*='ms-Callout-main'][class*='calloutMain-'],
  [class*='dropdownItemsWrapper-'] {
    background: ${(props: ThemeProps<ThemeProviderColors>) =>
      props.theme.popupInputMainBackground};
  }

  .ms-Dropdown-container {
    div:focus {
        i {
        color: ${(props: ThemeProps<ThemeProviderColors>) =>
          props.theme.textMainColor} !important;
    }
    #vacationType-option {
        color: ${(props: ThemeProps<ThemeProviderColors>) =>
          props.theme.textMainColor} !important;
      }
    }
    .ms-Dropdown-caretDownWrapper:hover,
    .ms-Dropdown-caretDownWrapper:active,
    .ms-Dropdown-caretDownWrapper:focus {
        i {
            color: ${(props: ThemeProps<ThemeProviderColors>) =>
              props.theme.textMainColor} !important;
        }
    }
  }

  .ms-Dropdown-container:hover,
  .ms-Dropdown-container:focus,
  .ms-Dropdown-container:active  {
   i {
       color: ${(props: ThemeProps<ThemeProviderColors>) =>
         props.theme.textMainColor} !important;
   }
   #vacationType-option {
       color: ${(props: ThemeProps<ThemeProviderColors>) =>
         props.theme.textMainColor} !important;
    }
  }

  @media (max-width: 710px) {
    [class*='ms-Dropdown-title'][id*='vacationType-option'] {
      height: 40px;
    }

    span[class*='readOnlyPlaceholder-'] {
      font-size: 16px;
    }

    span[id*='vacationType-option'] {
      font-size: 14px;
      padding: 4px 10px !important;
    }

    [class*="ms-Dropdown-caretDownWrapper"] {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
    }
  }
`;
